import ToggleSwitch from "./toggle-switch";
import { useState } from "react";
import shared from "../data/js/shared";
import { useNotifications, useAppSession } from "../contexts";
import { useSearch } from "@/contexts/SearchProvider";

const { localSwitchLabel } = shared.browse;

const LocalSearchSwitch = () => {
  const { createNotification } = useNotifications();

  const { setSearchParams, getSearchList, searchParams } = useSearch();
  const { setShippingAddress, shippingAddress, geoLocate } = useAppSession();
  const { lat, lng } = shippingAddress;
  const [local, toggleLocal] = useState(false);
  const [open, setOpen] = useState(!lat && !lng);
  const [locationText, setLocationText] = useState("");

  const closeClick = () => {
    setOpen(false);
  };

  const clickGeoLocate = async () => {
    navigator.geolocation.getCurrentPosition(
      async (e) => {
        if (!e.coords) return;
        const { latitude, longitude } = e.coords;
        const addy = await geoLocate({
          latitude: latitude.toString(),
          longitude: longitude.toString(),
          shippingName: '',
          line1: '',
          line2: '',
          locality: '',
          region: '',
          zipCode: '',
          countryId: '',
          isDefault: false,
        });
        if (!addy) return;
        setLocationText(`${addy.locality}, ${addy.region}`);
        setShippingAddress(addy);
        searchParams.latitude = latitude.toString();
        searchParams.longitude = longitude.toString();
        setSearchParams(searchParams);
        await getSearchList(searchParams);
      },
      (e) => {
        // The browser's own words when it gave any; otherwise (or for
        // POSITION_UNAVAILABLE) say the GPS is off.
        const msg = e.code === 2 || e.message.length === 0 ? "GPS is not available or disabled." : e.message;
        createNotification({ type: "error", msg, dismissed: false });
      }
    );
  };

  const toggleClick = () => {
    toggleLocal(!local);
    if (!local) {
      void clickGeoLocate();
    }
  };

  return (
    <div className={`localSearchSwitch ${open ? "STATE--open" : ""}`}>
      <ToggleSwitch onClick={toggleClick} checked={local} />
      <span onClick={toggleClick}>
        {local ? locationText : localSwitchLabel}
      </span>
      <a href="#" className="close-button" onClick={closeClick}>
        {"✕"}
      </a>
    </div>
  );
};
export default LocalSearchSwitch;
